import clsx from 'clsx';
import React, { Dispatch, SetStateAction } from 'react';

import useConfirmPopup from '@/src/components/common/Elements/Modal/useConfirmPopup';

import { LineEntry, RemoteOptions } from '../../../../types';
import { Draft } from '../../../../types/draft';
import { LineEntryForm, TreatmentForm } from '../../../../types/treatment';
import LineItemsModal from '../../../LineItems/LineItemsModal/LineItemsModal';
import LineItemsForm from '../LineItemsForm/LineItemsForm';

const LineItemsFormModal = ({
  lineItems,
  taxCalculation,
  dropdowns,
  currency,
  isAutomated,
  taxCalculationIsAutomated,
  draftLineEntries,
  draftTaxCalculation,
  setLineItems,
  setTaxCalculation,
  onClose,
  isPrefilled = false,
}: {
  lineItems: LineEntryForm[];
  taxCalculation: TreatmentForm['taxCalculation'];
  dropdowns: RemoteOptions['lineItems'];
  currency: TreatmentForm['currency'];
  isAutomated: boolean;
  taxCalculationIsAutomated: boolean;
  draftLineEntries: LineEntry[];
  draftTaxCalculation: Draft['payload']['taxCalculation'];
  setLineItems: Dispatch<SetStateAction<LineEntryForm[]>>;
  setTaxCalculation: Dispatch<SetStateAction<TreatmentForm['taxCalculation']>>;
  onClose?: () => void;
  isPrefilled?: boolean;
}) => {
  const [ConfirmClearLinesModal, confirmClearLines] = useConfirmPopup({
    classNames: '',
    modalWidth: '540px',
    title: 'Clear All Lines',
    message: `Are you sure you want to clear all lines?`,
    confirmBtn: {
      label: 'Proceed',
    },
  });

  return (
    <React.Fragment>
      <LineItemsModal
        containerClassName={clsx('tw-overflow-x-auto tw-scroll-styles')}
        fileViewerClasses={clsx('tw-h-[calc(100vh-415px)]')}
      >
        <LineItemsForm
          setLineItems={setLineItems}
          setTaxCalculation={setTaxCalculation}
          lineItems={lineItems}
          isAutomated={isAutomated}
          taxCalculationIsAutomated={taxCalculationIsAutomated}
          taxCalculation={taxCalculation}
          dropdowns={dropdowns}
          currency={currency}
          onClose={onClose}
          onConfirmClearLines={confirmClearLines}
          draftLineEntries={draftLineEntries}
          draftTaxCalculation={draftTaxCalculation}
          isPrefilled={isPrefilled}
        />
      </LineItemsModal>
      <ConfirmClearLinesModal />
    </React.Fragment>
  );
};

export default LineItemsFormModal;
